import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {ILookup} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

type ImageSourcesResponse = ILookup<number>[] | {data?: ILookup<number>[]};

export const fetchImageSourcesThunk: any = createAsyncThunk<ILookup<number>[]>(
  `${prefix} fetchImageSources`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getImageSources();
      const body = parsedBody as ImageSourcesResponse;

      if (Array.isArray(body)) {
        return body;
      }

      // Some PAM endpoints wrap collections in { data: [...] }.
      return Array.isArray(body?.data) ? body.data : [];
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch image sources. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
